export default __webpack_public_path__ + "static/media/xit.9633f691.png";